import React, { useState } from 'react';

// Styles & Assets
import styles from './ButtonStayTime.module.css';

// Services
import { formattedTimeBetweenDates } from '../../../services/Date';

// Hooks
import { useTranslation } from 'react-i18next';

// Components
import Modal from '../../UI/Modal/Modal';
import DialogChangeStayTime from '../DialogChangeStayTime/DialogChangeStayTime';

// Models
import { Patient } from '../../../interfaces/Patient';
import moment from 'moment';
interface Props {
    patient: Patient
}

const ButtonStayTime: React.FC<Props> = ({ patient }) => {

    const { t } = useTranslation()

    const [showModalEditTime, setShowModalEditTime] = useState(false);

    const caso = patient.cases?.[0];

    if (!caso) return <>-</>;
    const time = formattedTimeBetweenDates(caso.start_date, caso.end_date);
    if (time === null) return <>-</>;

    const { days, hours, minutes } = time;

    const onClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        setShowModalEditTime(true);
    }


    const timeStayString = `
    ${days ? `${days} ${t('days')}${hours ? ', ' : ''}` : ''}
    ${hours ? `${hours} ${t('hours')}${minutes ? ', ' : ''}` : ''}
    ${minutes ? `${minutes} ${t('minutes')}` : ''}
    `;



    return (
        <>
            <button
                className={styles.buttonStayTime}
                onClick={onClick}
                onMouseOver={e => e.stopPropagation()}
            >
                {timeStayString}
            </button>
            <Modal show={showModalEditTime} setShowModal={setShowModalEditTime}>
                <DialogChangeStayTime
                    patient={patient}
                    timeStayString={timeStayString}
                    defaultTime={moment(caso.start_date)}
                    closeModal={() => setShowModalEditTime(false)}
                />
            </Modal>
        </>
    );
};

export default ButtonStayTime;